import type { Locale } from './schemas.ts';

/**
 * Old WordPress permalinks → new routes, so existing links and search results keep working.
 * (WPML used `?lang=sq`; we use an /sq prefix.)
 */
export const LEGACY_ROUTES: Record<string, string> = {
  'services-ceo': '/services',
  'events-2026': '/events',
  'events-2025': '/events/2025',
  'events-2024': '/events/2024',
  'events-2023': '/events/2023',
  'our-events-2022': '/events/2022',
  'events-2021': '/events',
  'other-events-2022': '/other-events',
  'other-events-2020': '/other-events/2020',
  'other-events-2019': '/other-events/2019',
  'organization-of-international-trade-fairs':
    '/services/organization-of-international-trade-fairs',
  'organization-of-conferences-and-seminars': '/services/organization-of-conferences-and-seminars',
  'stands-and-professional-equipment-for-trade-fairs-and-exhibitions':
    '/services/stands-and-professional-equipment-for-trade-fairs-and-exhibitions',
  // Services the original site no longer offers.
  'marketing-services': '/services',
  'logistical-and-relocation-services': '/services',
  'organization-of-virtual-events-providing-virtual-trade-fair-platforms': '/services',
  'organizim-i-evente-virtuale-ofrues-i-platformave-per-panaire-virtuale': '/services',
};

export function publicLocalePath(locale: Locale, pathname: string): string {
  return locale === 'en' ? pathname : `/sq${pathname === '/' ? '' : pathname}`;
}

/** Resolve old links in one hop, retaining non-language query parameters. */
export function publicRedirect(originalUrl: string): string | null {
  const url = new URL(originalUrl, 'http://local.invalid');
  const original = url.pathname + url.search;
  if (url.pathname.startsWith('/api/') || url.pathname.startsWith('/uploads/')) return null;
  const pathname = url.pathname.replace(/\/+$/, '') || '/';
  const isAlbanian = /^\/sq(?:\/|$)/.test(pathname);
  const bare = (isAlbanian ? pathname.slice(3) : pathname) || '/';
  const lang = url.searchParams.get('lang');
  const locale = isAlbanian || lang === 'sq' ? 'sq' : 'en';
  const key = bare.slice(1);
  const legacy = Object.hasOwn(LEGACY_ROUTES, key) ? LEGACY_ROUTES[key] : undefined;
  const target = publicLocalePath(locale, legacy ?? bare);
  if (lang === 'sq' || lang === 'en') url.searchParams.delete('lang');
  const destination = target + url.search;
  return destination !== original ? destination : null;
}
